module.exports = __webpack_public_path__ + "img/w16b.bb805072.jpg";